export function detectPwaEnvironment (browser) {
  const navigator = browser.navigator || {}
  const userAgent = navigator.userAgent || ''
  const isAndroid = /Android/i.test(userAgent)
  const isIOS = /iPad|iPhone|iPod/i.test(userAgent) ||
    ((navigator.platform === 'MacIntel' || /Macintosh/i.test(userAgent)) && navigator.maxTouchPoints > 1)
  const isMobile = isAndroid || isIOS
  const isStandalone = navigator.standalone === true ||
    Boolean(browser.matchMedia?.('(display-mode: standalone)').matches)
  // The shipped APK exposes this bridge. A generic WebView is not exempt.
  const isNativeApp = isAndroid && typeof browser.app?.get_version === 'function' &&
    typeof browser.app?.get_client_info === 'function'

  return { isAndroid, isIOS, isMobile, isStandalone, isNativeApp, requiresInstall: isMobile && !isStandalone && !isNativeApp }
}

export function safeInstallReturnPath (value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return null
  if (value.includes('\\') || [...value].some(character => character.charCodeAt(0) <= 32)) return null
  if (/^\/install(?:[/?#]|$)/i.test(value)) return null
  return value
}

export function isPwaRouteAllowed (route, access) {
  return !access.requiresInstall || route.name === 'Install' ||
    (access.limitedAccess === true && route.meta?.allowWithoutInstall === true)
}

export function recordPwaInstalled (access) {
  access.deferredPrompt = null
  access.installCompleted = true
  access.error = ''
  access.message = ''
  // Installation is not permission to use the current browser tab.
}

export async function requestInstallPrompt (access, refreshEnvironment) {
  if (access.installing) return
  const prompt = access.deferredPrompt
  access.error = ''
  access.message = ''
  if (!prompt) {
    access.manualRequested = true
    return
  }
  access.installing = true
  try {
    await prompt.prompt()
    const choice = await prompt.userChoice
    if (choice.outcome === 'accepted') recordPwaInstalled(access)
    else access.message = 'نصب لغو شد. برای دسترسی به امکانات حساب، برنامه را نصب و از آیکن آن اجرا کنید.'
  } catch (_) {
    access.error = 'درخواست نصب انجام نشد. از منوی مرورگر نصب کنید یا راهنمای نصب دستی را ببینید.'
    access.manualRequested = true
  } finally {
    access.installing = false
    access.deferredPrompt = null
    refreshEnvironment()
  }
}

export function getNavigationRedirect (route, access) {
  if (!isPwaRouteAllowed(route, access)) {
    return { name: 'Install', query: { redirect: safeInstallReturnPath(route.fullPath) || '/' }, replace: true }
  }
  if (route.name === 'Install') {
    return access.requiresInstall ? null : { path: safeInstallReturnPath(route.query?.redirect) || '/', replace: true }
  }
  // Public-only mode must not bounce authenticated visitors to the account home.
  if (access.requiresInstall && access.limitedAccess) return null
  if (!access.welcomeSeen && route.name !== 'Welcome') return { name: 'Welcome' }
  if (access.welcomeSeen && route.name === 'Welcome') return { name: access.token ? 'Home' : 'Login' }
  if (route.matched?.some(record => record.meta.requiresAuth) && !access.token) {
    return { name: 'Login', query: { redirect: route.fullPath } }
  }
  if (route.matched?.some(record => record.meta.guestOnly) && access.token) return { name: 'Home' }
  return null
}
